import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/editsGroup.svg'
import { Actor } from './Actor'
import Avatar from 'common/Avatar/Avatar'
import { ActivityEventPosition, ActivityEventSelection, EditsGroupEvent } from './Types'
import { pluralize } from 'utils'
import { NestedActivityEvent } from './NestedActivityEvent'
import { useActivityTimelineContext } from 'components/ActivityTimeline/ActivityTimelineContext'
import { getInitials } from 'utils'

interface Props extends ActivityEventPosition, ActivityEventSelection {
  event: EditsGroupEvent
}

const EditsGroup = ({ event, ...props }: Props) => {
  const { user_count, data } = event
  const totalEditsCount = data.length
  const {
    event: contextEvent,
    nestedEvent: contextNestedEvent,
    onSelectEvent,
    disabledEventId,
  } = useActivityTimelineContext()

  const isInitiallyOpen = () => {
    if (!contextNestedEvent?.id) return false

    return contextNestedEvent.id.split('-')[0] === event.id.toString()
  }

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      isSelected={event.id === contextEvent?.id && !contextNestedEvent}
      initiallyOpen={isInitiallyOpen()}
      content={
        <>
          <Actor
            count={user_count}
            displayName={data[0].user_display_name || 'Anonymous User'}
            userId={data[0]?.user_id}
          />{' '}
          made {totalEditsCount} {pluralize('edit', totalEditsCount)}
        </>
      }
      nestedContent={
        user_count > 1 &&
        data.map((group) => {
          const { user_display_name, user_avatar_url, user_id } = group
          return (
            <NestedActivityEvent
              key={`${event.id}-${group.id}`}
              avatar={
                <Avatar size={20} url={user_avatar_url} label={getInitials(user_display_name) || 'Anonymous User'} />
              }
              content={
                <>
                  <Actor displayName={user_display_name || 'Anonymous User'} userId={user_id} /> made 1 edit
                </>
              }
              timestamp={group.timestamp}
              isSelected={contextNestedEvent?.id === group.id}
              onClick={(e) => {
                e.stopPropagation()
                if (String(disabledEventId) === String(event.id)) return
                onSelectEvent(event)
              }}
            />
          )
        })
      }
    />
  )
}

export { EditsGroup }
